const awsmobile = {
  aws_project_region: 'ap-southeast-1',
  aws_cognito_identity_pool_id: 'ap-southeast-1:f199f88e-4b3c-4f1b-87e6-3e5faaf9f18e',
  aws_cognito_region: 'ap-southeast-1',
  aws_user_pools_id: 'ap-southeast-1_iAXNhyFhi',
  aws_user_pools_web_client_id: '34a3j7k8rjebdoa5k168ltvv5t',
  oauth: {}
}

export default awsmobile
